module.exports = __webpack_public_path__ + "img/common_service_4.751fac76.png";